import { render } from "./CalendarEvents.vue?vue&type=template&id=5b8cc761&scoped=true"
import script from "./CalendarEvents.vue?vue&type=script&lang=js"
export * from "./CalendarEvents.vue?vue&type=script&lang=js"

import "./CalendarEvents.vue?vue&type=style&index=0&id=5b8cc761&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\Tegra\\abrafarma\\abrafarma-app-ionic-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8cc761"]])

export default __exports__